// Mock data for IP Partners Inc legal services website

export const heroData = {
  title: "Expert Legal Solutions for Your Business & Personal Needs",
  subtitle: "Attorney-backed legal services you can trust. Get professional legal help for business, personal matters, and intellectual property protection.",
  ctaText: "Get Legal Help",
  heroImage: "https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d"
};

export const services = [
  { name: "Corporate & Business Contracts", slug: "corporate-business-contracts" },
  { name: "Corporate & Business Formation", slug: "corporate-business-formation" },
  { name: "Business Transaction", slug: "business-transaction" },
  { name: "Mergers & Acquisitions", slug: "mergers-acquisitions" },
  { name: "Non-Profit Law", slug: "non-profit-law" },
  { name: "Government Contracting", slug: "government-contracting" },
  { name: "Business Disputes", slug: "business-disputes" },
  { name: "Anti-Corruption Compliance", slug: "anti-corruption-compliance" },
  { name: "Immigration", slug: "immigration" },
  { name: "Trademark Registration", slug: "trademark-registration" },
  { name: "Copyright Registration", slug: "copyright-registration" }
];

export const serviceCards = [
  {
    id: "corporate",
    title: "Corporate & Business Law",
    description: "Comprehensive legal solutions for corporations, startups, and entrepreneurs",
    icon: "briefcase",
    image: "https://images.pexels.com/photos/4427430/pexels-photo-4427430.jpeg"
  },
  {
    id: "compliance",
    title: "Compliance & Government",
    description: "Expert guidance on regulatory compliance and government contracting",
    icon: "shield",
    image: "https://images.pexels.com/photos/6077797/pexels-photo-6077797.jpeg"
  },
  {
    id: "ip",
    title: "Intellectual Property",
    description: "Protect your brand with trademark and copyright registration services",
    icon: "award",
    image: "https://images.unsplash.com/photo-1562564055-71e051d33c19"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Tell Us Your Needs",
    description: "Fill out our simple form describing your legal situation",
    icon: "clipboard"
  },
  {
    step: 2,
    title: "Get Matched",
    description: "We connect you with the right attorney for your case",
    icon: "user-check"
  },
  {
    step: 3,
    title: "Receive Expert Guidance",
    description: "Work with experienced attorneys to resolve your legal matters",
    icon: "scale"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Richardson",
    role: "CEO, TechVenture Solutions",
    content: "IP Partners guided us through a complex M&A transaction with exceptional professionalism. Their expertise saved us millions and ensured a smooth process.",
    rating: 5
  },
  {
    id: 2,
    name: "Jennifer Martinez",
    role: "Founder, Martinez Consulting Group",
    content: "Outstanding trademark registration service. They protected our brand globally and provided strategic advice that was invaluable for our expansion.",
    rating: 5
  },
  {
    id: 3,
    name: "Robert Thompson",
    role: "Director of Operations, GlobalTech Inc",
    content: "Their business formation expertise helped us structure our company optimally. Professional, responsive, and deeply knowledgeable.",
    rating: 5
  },
  {
    id: 4,
    name: "Sarah Williams",
    role: "Managing Partner, Williams & Associates",
    content: "Exceptional anti-corruption compliance guidance. IP Partners helped us implement robust policies that gave our stakeholders complete confidence.",
    rating: 5
  },
  {
    id: 5,
    name: "David Anderson",
    role: "VP Legal Affairs, Anderson Enterprises",
    content: "Their contract drafting services are second to none. Every agreement is thorough, clear, and protects our interests perfectly.",
    rating: 5
  },
  {
    id: 6,
    name: "Lisa Chen",
    role: "Executive Director, Chen Foundation",
    content: "IP Partners expertly handled our non-profit formation and 501(c)(3) application. Their attention to detail made the process seamless.",
    rating: 5
  }
];

export const faqs = [
  {
    question: "How quickly can I get legal help?",
    answer: "Most consultations are scheduled within 24-48 hours. For urgent matters, we offer expedited services to connect you with an attorney immediately."
  },
  {
    question: "What are your service fees?",
    answer: "Our fees vary depending on the service type and complexity. We offer transparent pricing with no hidden costs. Contact us for a detailed quote tailored to your needs."
  },
  {
    question: "Are your attorneys licensed?",
    answer: "Yes, all attorneys in our network are fully licensed, vetted professionals with years of experience in their respective practice areas."
  },
  {
    question: "Do you handle cases nationwide?",
    answer: "We work with attorneys across the United States. Our network allows us to serve clients in all 50 states for various legal matters."
  },
  {
    question: "Can I get a consultation before committing?",
    answer: "Absolutely! We offer initial consultations to discuss your case, understand your needs, and provide guidance on the best path forward."
  },
  {
    question: "What should I bring to my first consultation?",
    answer: "Please bring any relevant documents, contracts, correspondence, or records related to your legal matter. Our team will provide a specific checklist based on your case type."
  },
  {
    question: "How long does the legal process typically take?",
    answer: "Timelines vary significantly depending on the complexity of your case and the legal matter involved. We provide estimated timeframes during your consultation and keep you updated throughout."
  },
  {
    question: "Do you offer virtual consultations?",
    answer: "Yes, we offer both in-person and virtual consultations via video conference to accommodate your schedule and preferences."
  },
  {
    question: "What makes IP Partners Inc different from other law firms?",
    answer: "Our combination of deep expertise, personalized attention, transparent pricing, and proven track record sets us apart. We focus on building long-term client relationships."
  }
];

export const companyInfo = {
  name: "IP Partners Inc",
  email: "info@ippartnerinc.com",
  address: "1990 N California Blvd, Walnut Creek, CA 94596, United States",
  phone: "+1 (833) 201-7574"
};

export const footerLinks = {
  services: {
    title: "Legal Services",
    links: [
      { name: "Corporate & Business Contracts", href: "/services/corporate-business-contracts" },
      { name: "Corporate & Business Formation", href: "/services/corporate-business-formation" },
      { name: "Business Transaction", href: "/services/business-transaction" },
      { name: "Mergers & Acquisitions", href: "/services/mergers-acquisitions" },
      { name: "Non-Profit Law", href: "/services/non-profit-law" },
      { name: "Government Contracting", href: "/services/government-contracting" }
    ]
  },
  quickLinks: {
    title: "Quick Links",
    links: [
      { name: "About Us", href: "/about" },
      { name: "Meet the Attorney", href: "/attorney" },
      { name: "Contact Us", href: "/contact" },
      { name: "Services", href: "/#services" }
    ]
  }
};

export const serviceDetails = {
  "corporate-business-contracts": {
    title: "Corporate & Business Contracts",
    description: "Professional contract drafting and review to protect your business interests",
    fullDescription: "Well-drafted contracts are the foundation of successful business relationships. Our attorneys create clear, enforceable agreements tailored to your specific needs, covering employment, vendors, clients, partnerships, and more.",
    benefits: [
      "Legally sound and enforceable contracts",
      "Protection of your business interests",
      "Clear terms to prevent disputes",
      "Compliance with applicable laws",
      "Professional contract review services",
      "Negotiation support"
    ],
    process: [
      "Understand your contract needs and goals",
      "Draft comprehensive agreement tailored to your business",
      "Review, negotiate, and finalize with all parties"
    ]
  },
  "corporate-business-formation": {
    title: "Corporate & Business Formation",
    description: "Start your business with proper legal structure and compliance",
    fullDescription: "Our business formation services help entrepreneurs and companies establish the right legal foundation. We assist with LLC formation, S-Corp and C-Corp setup, partnership agreements, and ensure compliance with state and federal regulations.",
    benefits: [
      "Choose the right business structure for your needs",
      "File necessary documents with state authorities",
      "Obtain required licenses and permits",
      "Draft operating agreements and bylaws",
      "Minimize personal liability",
      "Optimize tax structure"
    ],
    process: [
      "Consultation to understand business goals and recommend structure",
      "Prepare and file all formation documents with authorities",
      "Draft governing documents and provide ongoing compliance support"
    ]
  },
  "business-transaction": {
    title: "Business Transaction",
    description: "Expert guidance for complex business transactions and negotiations",
    fullDescription: "Navigate business transactions with confidence. Our attorneys provide comprehensive support for asset purchases, stock sales, joint ventures, and other complex business deals to ensure your interests are protected.",
    benefits: [
      "Due diligence and risk assessment",
      "Transaction structure optimization",
      "Contract negotiation and drafting",
      "Regulatory compliance guidance",
      "Tax efficiency planning",
      "Post-transaction support"
    ],
    process: [
      "Transaction assessment, planning, and due diligence investigation",
      "Structure deal terms, negotiate, and draft transaction documents",
      "Coordinate closing process and provide post-closing support"
    ]
  },
  "mergers-acquisitions": {
    title: "Mergers & Acquisitions",
    description: "Strategic legal counsel for mergers, acquisitions, and corporate restructuring",
    fullDescription: "Our M&A attorneys guide clients through the complexities of mergers, acquisitions, and corporate restructuring. We provide strategic counsel to maximize value and minimize risk throughout the transaction lifecycle.",
    benefits: [
      "Comprehensive due diligence",
      "Deal structure optimization",
      "Regulatory and antitrust compliance",
      "Integration planning support",
      "Risk mitigation strategies",
      "Post-merger dispute resolution"
    ],
    process: [
      "Strategic planning, target identification, and valuation",
      "Negotiate terms, structure deal, and draft definitive agreements",
      "Manage regulatory approvals, close transaction, and support integration"
    ]
  },
  "non-profit-law": {
    title: "Non-Profit Law",
    description: "Comprehensive legal services for non-profit organizations and charities",
    fullDescription: "Support your mission with proper legal guidance. Our non-profit attorneys help organizations with formation, tax-exempt status, compliance, governance, and all legal matters affecting charitable organizations.",
    benefits: [
      "501(c)(3) tax-exempt status application",
      "Non-profit formation and bylaws",
      "Board governance guidance",
      "Compliance with state and federal regulations",
      "Grant and contract review",
      "Donor agreements and planned giving"
    ],
    process: [
      "Organization formation consultation and file articles of incorporation",
      "Apply for tax-exempt status and develop governance policies",
      "Ongoing compliance monitoring and annual reporting assistance"
    ]
  },
  "government-contracting": {
    title: "Government Contracting",
    description: "Navigate federal and state government contracting requirements",
    fullDescription: "Successfully compete for government contracts with expert legal guidance. Our attorneys help businesses navigate the complex regulations, compliance requirements, and bid processes for federal, state, and local government contracts.",
    benefits: [
      "Contract proposal review",
      "Compliance with FAR and DFARS",
      "Small business certifications (8(a), WOSB, etc.)",
      "Bid protest representation",
      "Contract negotiation support",
      "Claims and disputes resolution"
    ],
    process: [
      "Assess eligibility, certifications, and prepare bid proposals",
      "Negotiate contract terms and ensure regulatory compliance",
      "Manage contract performance and handle disputes or claims"
    ]
  },
  "business-disputes": {
    title: "Business Disputes",
    description: "Strategic litigation and dispute resolution for business conflicts",
    fullDescription: "Resolve business disputes effectively through negotiation, mediation, arbitration, or litigation. Our experienced litigators protect your interests in contract disputes, partnership conflicts, shareholder disagreements, and more.",
    benefits: [
      "Experienced litigation attorneys",
      "Alternative dispute resolution (ADR)",
      "Contract dispute resolution",
      "Partnership and shareholder disputes",
      "Breach of fiduciary duty claims",
      "Business tort litigation"
    ],
    process: [
      "Case evaluation, strategy development, and pre-litigation negotiation",
      "File complaint or answer, conduct discovery and gather evidence",
      "Motion practice, hearings, trial, or settlement resolution"
    ]
  },
  "anti-corruption-compliance": {
    title: "Anti-Corruption Compliance",
    description: "FCPA compliance and anti-corruption program development",
    fullDescription: "Protect your business from corruption risks with comprehensive compliance programs. Our attorneys help companies develop and implement anti-corruption policies compliant with FCPA, UK Bribery Act, and international standards.",
    benefits: [
      "FCPA and anti-bribery compliance programs",
      "Risk assessment and due diligence",
      "Policy development and training",
      "Third-party vendor screening",
      "Internal investigation support",
      "Government enforcement defense"
    ],
    process: [
      "Compliance risk assessment and develop anti-corruption policies",
      "Implement due diligence procedures and conduct employee training",
      "Monitor, audit compliance, and respond to allegations or investigations"
    ]
  },
  "immigration": {
    title: "Immigration",
    description: "Business immigration services for employers and employees",
    fullDescription: "Navigate the complexities of business immigration law. Our attorneys assist employers with visa sponsorship, work permits, and compliance, helping businesses hire and retain international talent.",
    benefits: [
      "Employment-based visa sponsorship (H-1B, L-1, O-1)",
      "PERM labor certification",
      "Green card applications",
      "I-9 compliance and audits",
      "Executive and investor visas (E-2, EB-5)",
      "Immigration policy development"
    ],
    process: [
      "Assess immigration options and prepare visa petition or application",
      "File with USCIS/DOL/DOS and respond to requests for evidence",
      "Attend interviews if required and obtain visa approval or status adjustment"
    ]
  },
  "trademark-registration": {
    title: "Trademark Registration",
    description: "Protect your brand identity with comprehensive trademark services",
    fullDescription: "Your brand is valuable. Our trademark attorneys help you register, protect, and enforce your trademarks to safeguard your business identity and prevent infringement in the marketplace.",
    benefits: [
      "Comprehensive trademark search",
      "Federal trademark registration with USPTO",
      "International trademark protection",
      "Brand monitoring services",
      "Infringement enforcement",
      "Licensing agreement drafting"
    ],
    process: [
      "Initial trademark search, analysis, and clearance review",
      "Prepare and file USPTO application, respond to office actions",
      "Obtain registration certificate and provide ongoing trademark maintenance"
    ]
  },
  "copyright-registration": {
    title: "Copyright Registration",
    description: "Secure legal protection for your creative works and content",
    fullDescription: "Protect your original works with copyright registration. Our attorneys help register copyrights for literary works, software, music, art, and other creative content, and enforce your rights against infringement.",
    benefits: [
      "Copyright registration with U.S. Copyright Office",
      "Protection for software, books, art, music",
      "Licensing and assignment agreements",
      "Infringement monitoring and enforcement",
      "DMCA takedown notices",
      "Copyright litigation support"
    ],
    process: [
      "Identify copyrightable works and prepare registration application",
      "File with U.S. Copyright Office and respond to examiner questions",
      "Obtain copyright registration and enforce rights against infringement"
    ]
  }
};

// Form submission mock (will be replaced with backend)
export const submitContactForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock form submission:", formData);
      resolve({ success: true, message: "Thank you! We'll contact you within 24 hours." });
    }, 1000);
  });
};
